import React from 'react';

import { cn } from '@/src/util/ui';

import Card from '../Card';

type TileCardProps = {
  children;
  className: string;
  isActive?: boolean;
};

const TileCard = ({ children, className, isActive, ...otherProps }: TileCardProps) => {
  return (
    <Card
      className={cn(
        `card--container_tile tw-px-[20px] tw-py-[10px] 
        tw-border-[1px] tw-border-solid tw-border-transparent tw-rounded-[10px] 
        tw-shadow-[0px_0px_2px_0px_rgba(0,0,0,0.10)] 
        hover:tw-border-cfo-blue-300 hover:tw-bg-cfo-blue-200 hover:tw-shadow-[1px_2px_4px_0px_rgba(80,129,255,0.20)] hover:tw-cursor-pointer`,
        className,
        isActive &&
          `tw-border-cfo-blue-300 tw-bg-cfo-blue-200 tw-shadow-[1px_2px_4px_0px_rgba(80,129,255,0.20)] tw-cursor-pointer`
      )}
      {...otherProps}
    >
      {children}
    </Card>
  );
};

export default TileCard;
